<template>
    <div class="google-address">
        <VueGoogleAutocomplete
            :id="id"
            :label="label"
            :class="'addressbox'"
            placeholder=""
            :country="['au', 'nz']"                        
            :value="address"
            v-on:placechanged="getAddressData"
            outlined
            autocomplete="new-password"
            @focus="isFocused = true"
            @blur="isFocused = false"
            @change="searchText"
        >
        </VueGoogleAutocomplete>
        <v-text-field
            ref="input"
            :label="label"
            class="hidden-input"
            :value="address"
            :rules="required ? notEmpty : []"
            outlined
        ></v-text-field>
    </div>
</template>
<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
    props: {
        id: String,
        address: String,
        label: String,
        required: Boolean
    },
    components: {
        VueGoogleAutocomplete,
    },
    mounted() {
        setTimeout(() => {
            const el = document.getElementById(this.id);
            el.setAttribute('autocomplete', 'new-password')
            this.currentSearchText = this.address;
        }, 1000)
        this.rootEl = this.$refs.input.$el;
        this.labelEl = this.rootEl.getElementsByTagName('label')[0];
        this.legendEl = this.rootEl.getElementsByTagName('legend')[0];
    },
    data() {
        return {
            isFocused: false,
        }
    },
    computed: {
        notEmpty() {
            return [v => Boolean(v) && v.trim().length > 0 || 'Please pick an address']
        }, 
    },
    methods: {
        getAddressData(address) {
            this.$emit('on-address', address);
        },  
        focusHiddenInput() {
            this.rootEl.classList.add('v-input--is-focused');
            this.rootEl.classList.add('primary--text');
            this.labelEl.classList.add('v-label--active');
            this.labelEl.classList.add('primary--text');
            this.legendEl.setAttribute('style', 'width: 55px;');
        },
        blurHiddenInput() {
            this.rootEl.classList.remove('v-input--is-focused');
            this.labelEl.classList.remove('v-label--active');
            this.labelEl.classList.remove('primary--text');
            this.legendEl.setAttribute('style', 'width: 0px;');
        },
        removePrimary() {
            this.rootEl.classList.remove('v-input--is-focused');
            this.labelEl.classList.remove('primary--text');
        },
        searchText(val) {
            this.currentSearchText = val;
        },
        // restoreAddressValue(inputEl) {
        //     if(this.currentSearchText !== inputEl.value) {
        //         inputEl.value = this.address;
        //     }
        // }
    },
    watch: {
        isFocused(val) {
            if(val) {
                return this.focusHiddenInput();
            }
            // const rootEl = this.$refs.input.$el;
            // const inputEl = rootEl.getElementsByTagName('input')[0];
            // if(this.address) {
            //     return this.restoreAddressValue(inputEl);
            // }
            if(!this.currentSearchText && !this.address) {
                this.blurHiddenInput();
            } else {
                this.removePrimary();
            }
        }
    }
}
</script>
<style lang="scss">
.google-address {
    position: relative;
    height: 56px;
    margin-bottom: 30px;
    >input {
        position: absolute;
        z-index: 1;
    }
}
.hidden-input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    input {
        color: transparent !important;
    }
}
.addressbox {
    width:100%;
    margin: 10px 0;
    padding: 0 10px;
    height: 36px;
    outline: none;
    border: none;
    // border: 2px solid #8e8e8c;
    // border-radius: 3px;
}
</style>
